import React, { useContext, useEffect, useState } from "react";
import Header from "../../CoustamComponent/Header";
import { Link, useLocation } from "react-router-dom";
import { ProfileContext } from "../../../Services/ProfileProvider";
import AuthService from "../../../Services/ApiServices/AuthService";
import { alertErrorMessage } from "../../../Services/CustomAlertModel";

const ConditionsPage = () => {

	const location = useLocation();
	const { wlletBalance,userDetails } = useContext(ProfileContext);
	const [conditionData, setConditionData] = useState([]);
	const KycStatus = userDetails?.kycVerified;


	const formatNumber = (number) => {
		return new Intl.NumberFormat('en-US').format(number);
	}

	const handleTermsandCondition = async () => {
		try {
			const result = await AuthService.getTermsCondition();
			if (result?.success) {
				setConditionData(result?.data);
			} else {
				alertErrorMessage(result?.message);
			}
		} catch (error) {
			alertErrorMessage(error);
		}
	};

	useEffect(() => {
		handleTermsandCondition();
	}, [])

	return (
		<div class="wrapper saprate_page ">
			<div class=" page-body ">
				<div class="page-wrap">
					<Header />
					<div className="page_wrapper copier_wrapper" >
						<div className="ct-header__top">
							<div className="container">
								<div className="ct-header__inner">
									<h2 className="ct-header__name">
										Copy Trading
									</h2>
									<div className="ct-header__wallet">
										<div className="ct-wallet">
											<div className="ct-wallet__balance">
												<div className="ct-wallet__head"> Wallet balance </div>
												<div className="ct-wallet__count">
													<div className="ct-wallet__count-int"> ${formatNumber(wlletBalance?.balance?.toFixed(2) || 0)} </div>
												</div>
											</div>
											{KycStatus === 2 &&
												<div className="ct-wallet__nav">
													<Link to="/withdraw" className="ct-wallet__withdrawal btn btn-primary-light btn-sm">
														Withdrawal
													</Link>
													<Link to="/deposit" className="ct-wallet__deposit btn btn-primary btn-sm">
														Deposit
													</Link>
												</div>
											}
										</div>
									</div>
								</div>

								<div className="page_tabs">
									<div className="nav nav-tabs" id="nav-tab" role="tablist">
										<Link className={`nav-link ${location?.pathname === "/copy_trading" && "active"}`} id="nav-Rating-tab" to="/copy_trading">Rating</Link>
										<Link className={`nav-link ${location?.pathname === "/copier_area" && "active"}`} id="nav-Copier-tab" to={KycStatus === 2 ? "/copier_area" : "/update_kyc"}>Copier Area</Link>
										<Link className={`nav-link ${location?.pathname === "/terms_conditions" && "active"}`} id="nav-tandc-tab" to="/terms_conditions">Terms & Conditions</Link>
									</div>
								</div>
							</div>
						</div>

						<div className="page_wrapper " >
							<div className="container" >
								<div class="row justify-content-center mt-md-5">
									<div class="col-lg-10">
										<div className=" terms_content" >
											<div className="card" >
												<div className="card-body" >
													<h3>
														{conditionData?.title}
													</h3>
													<p>
														{conditionData?.description}
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ConditionsPage


